// extracted by mini-css-extract-plugin
export var content = "sidebar-module--content--kXHaa";
export var image = "sidebar-module--image--LI+0U";
export var modalBody = "sidebar-module--modalBody--rfQ++";
export var modalButton = "sidebar-module--modalButton--37L9-";
export var sbShowMain = "sidebar-module--sb-show-main--gHeEb";
export var sectionTitle = "sidebar-module--sectionTitle--Aj5Q7";
export var subscribe = "sidebar-module--subscribe--nwWZz";
export var wrapper = "sidebar-module--wrapper--MCUoF";